// extracted by mini-css-extract-plugin
module.exports = {"Empty_container":"CustomEmpty_Empty_container__fNctG","container":"CustomEmpty_container__YHIHw","msg":"CustomEmpty_msg__xMjYD","btn":"CustomEmpty_btn__MTKLM"};